<template>
  <div class="channelsBoard">
    <p>
      Podrás gestionar los canales con los que estas trabajando en tu negocio.
      <a :href="DOCS_URL" target="_blank" rel="noopener noreferrer">Click aquí</a> para conocer más.
    </p>
    <div>
      <a-select
        :getPopupContainer="(triggerNode) => triggerNode.parentNode"
        v-model:value="channel"
        class="selectChannel"
      >
        <a-select-option :key="0"> Todos los canales </a-select-option>
        <a-select-option :key="7"> Voz </a-select-option>
        <!-- // Hidden SMS for PoC -->
        <a-select-option :key="2"> SMS </a-select-option>
        <a-select-option :key="3"> WhatsApp Message</a-select-option>
        <a-select-option :key="5"> Web Chat </a-select-option>
        <a-select-option :key="6"> FB Messenger </a-select-option>
        <a-select-option :key="ChannelType.Instagram"> Instagram </a-select-option>
        <a-select-option :key="9"> Email </a-select-option>
        <a-select-option :key="10"> WhatsApp Voice</a-select-option>
      </a-select>
      <TableListChannels @reloadTable="handleFetchChannels" :loading="loading" />
    </div>
  </div>
</template>

<script>
import TableListChannels from "@/app/channels/components/tables/TableListChannels.vue";

import { ChannelType } from "@/app/shared/utils/enums";

export default {
  name: "ChannelsBoardTemplate",
  components: { TableListChannels },
  data() {
    const DOCS_URL = `${import.meta.env.VITE_WEB_DOC}/conexiones/mis-canales/`;

    return {
      channel: 0,
      ChannelType,
      loading: false,
      DOCS_URL,
    };
  },
  mounted() {
    this.$store.dispatch("fetchAllChannelsCustomers");
    this.$store.dispatch("fetchAllCountries");
  },
  methods: {
    async handleFetchChannels() {
      this.loading = true;

      await this.$store.dispatch("fetchAllChannelsCustomers", {
        channelId: this.channel,
      });

      this.loading = false;
    },
  },
  watch: {
    channel() {
      this.handleFetchChannels();
    },
  },
};
</script>

<style lang="sass" scoped>
.channelsBoard
  padding: 8px 20px
.container
  margin: 12px 120px
.selectChannel
  width: 180px !important
  margin-bottom: 10px
.title
  font-weight: 600
  font-size: $font-large
  line-height: 28px
  color: $gray-9
  margin-bottom: 10px
</style>
